
jQuery(function($) {
  	 

  /* VAR */

  var l_window = $(window).width();
  var h_window = $(window).height();
  var header = $('#masthead');
  var top_sticky = 40;
  if($('body').hasClass('admin-bar')) top_sticky = parseInt(top_sticky + 32);




/*********************************/
/** DIAPORAMA TOP HOME PAGE **/
/*********************************/

  $('.js-SlideTopHome').slick({
        //setting-name: setting-value
      dots: false,
      arrows:true,
      draggable:true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover:false,
      pauseOnFocus:true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed:700,
     // fade: true, // a tester //
      cssEase: 'ease-in-out',
      rows: 0,
       responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          dots: true,
        }
      }
    ]
       
});




  /******************************************/
    /********** LIGHTBOX VIDEO HOME PAGE *************/
  /******************************************/
    // https://stackoverflow.com/questions/45825465/videojs-responsive-lightbox-not-working
    // https://github.com/rudkovskyi/videojs_popup
    // https://dimsemenov.com/plugins/magnific-popup/documentation.html#options
   if($(".open-popup-link"). length){
    videojs.options.flash.swf = "video-js.swf";
    $('document').ready(function(){
      $('.open-popup-link').magnificPopup({
        type:'inline',
        midClick: true,
        mainClass: 'mfp-fade',
        callbacks: {
        open: function() {
           videojs('showreel_lightbox').play();
        },
        close: function() {
          videojs('showreel_lightbox').pause();
        }
        // e.t.c.
      }

      });
      // $('.open-popup-link').on('click',function(){
      //   videojs('showreel_lightbox').play();
      // });
    });
  }







/* **************************************************  */
  /* NICSELECT */
/* **************************************************  */

$('.to_nicedropdown-js').each(function( index ) {
  $(this).find('option:first-child').text('objet');
});
  $('.to_nicedropdown-js').niceSelect();


// niceselect pour les cats 
 $('.to_nicedropdowncat-js').niceSelect();

  $('.ActionToChild-js').on('change', function() {
    document.location=this.value;
  });

   /*************/
      /* ISOTOPE + MASONRY _ PROJETS */
    /*************/

 var $grid = $('.grid-container').imagesLoaded( function() {
      $grid.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        // use outer width of grid-sizer for columnWidth
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer'
      }
    });
  });



    /* **************************************************  */
  /* GALERY DANS LES POSTS OU REALISATIONS */
  /* **************************************************  */

   $("#lightgallery").lightGallery({
       subHtmlSelectorRelative: true
  }); 



  $(".wysiwyg .gallery").lightGallery({
      selector:'a',
      subHtmlSelectorRelative: true
  }); 

  /* **************************************************  */
  /* Redimensionnement des videos (iframes, si il y en a ! ) */
  /* **************************************************  */


   $(".BlocTwoCol-Container, .BlocCenterTxt, .BlocCenterVideo").fitVids();



  /* **************************************************  */
  /* SLIDER CHIFFRE CLES */
  /* **************************************************  */


  $('.ChiffresCles-Slider').slick({
        //setting-name: setting-value
        dots: false,
        arrows:true,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:1400,
        //fade: true,
        pauseOnHover:false,
        pauseOnFocus:false,
     //   infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
               autoplaySpeed: 3000,
            }
          }
          // settings: "unslick"
          // instead of a settings object
        ]
   });




    /* **************************************************  */
  /* BTN OPEN / CLOSE REASEAUX SOCIAUX */
  /* **************************************************  */

     $(".RSMaison-button").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        
        $(this).parent().removeClass('active');
        $(this).attr('aria-expanded', 'false');
        $(this).next().slideUp(300);

       // console.log('h_window = '+ h_window);
          // M0,1080c0,0-11-296.832-11-565C-11,246,0,0,0,0S-57,533,0,1080z
          // mask_forme_menu_svg.stop().animate(2000, 'backOut',0).plot('M0,'+h_window+'c0,0-11-'+l_296+'-11-'+l_565+'C-11,'+l_246+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z'); // podom 2000 au lieu de 1300
      }else{
         $(this).parent().addClass('active');
         $(this).attr('aria-expanded', 'true');
          $(this).next().slideDown(300);


         // mask_forme_menu_svg.stop().animate(0, '-',0).plot('M0,'+h_window+'c0,0,'+l_window+'-'+quart_h_courbe+','+l_window+'-'+middle_h+'C'+l_window+','+parseInt(quart_h_courbe+5)+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z');
      }
   });  


    /* **************************************************  */
  /* SLIDER ONLY MOBILE */
  /* **************************************************  */

  $slick_slider = $('.HomePostResume-SliderMobile');
  settings_slider = {
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows:true,
  dots: true,
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows:true,
        dots: true,
      }
    }
  ]
    // more settings
  };

  slick_on_mobile( $slick_slider, settings_slider);

// slick on mobile
  function slick_on_mobile(slider, settings){
    $(window).on('load resize', function() {
      if ($(window).width() > 1023) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return;
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  }


  /* *****************  */
  /* FEATHERLIGHT / INSCPRIPTION NEWSLETTER */
/* *****************  */

$('.TeamItem-Btn button').each(function(_i, elt){
  $(elt).featherlight(
    {
    targetAttr : 'data-destination-lightbox',
    persist:false,        
    otherClose : 'span.close-container',
    openSpeed:      400,                   /* Duration of opening animation */
   closeSpeed:     400,     
   afterOpen: function(event){
    $(this.$instance).addClass('ready_to_display'); // alert class of content
  } 
  });

});

$('.TeamItem-Img').each(function(_i, elt){
  $(elt).featherlight(
    {
    targetAttr : 'data-destination-lightbox',
    persist:false,    
    otherClose : 'span.close-container',
    openSpeed:      400,                   /* Duration of opening animation */
   closeSpeed:     400,   afterOpen: function(event){
    $(this.$instance).addClass('ready_to_display'); // alert class of content
  } 
  });
  
});

// $('.TeamItem-Btn button').featherlight(
//     //$('#'+$(this).attr('data-destination-lightbox'))
//     //$(".LALALA"),
//     {
//     targetAttr : 'data-destination-lightbox',
//     type : "html",
//     persist:'shared',        
//     otherClose : 'span.close-container',
//   });

//   $('.TeamItem-Img').featherlight(
//     //$('#'+$(this).attr('data-destination-lightbox'))
//     //$(".LALALA"),
//     {
//     targetAttr : 'data-destination-lightbox',
//     type : "html",
//     persist:'shared',        
//     otherClose : 'span.close-container',
//   });



/* Agence / Test hover forme */
 var togTeamMember = $('.TeamItem'),
     togItemsArray;

var GlobalMask, MaskInnerBlue;

 function hoverOn(elt){
    GlobalMask = $(elt).find('path.mask_anime__1');
    MaskInnerBlue = $(elt).find('path.formebleu');
    console.log(MaskInnerBlue);
    togItemsArray = [GlobalMask, MaskInnerBlue];
     var anim_morph_agence = gsap.to(GlobalMask, {morphSVG:"M142.606,3.318C47.06,24.734,51.333,40.884,37.503,47.768C-22.469,77.617,1.156,178.394,1.248,225.004c0.251,129.669,205.55,85.605,256.666,18.17c7.877-10.395,23.561-93.711,11.312-121.574c-25.045-56.968,20.415-78.316-11.089-82.282C238.985,36.909,216.078-13.149,142.606,3.318L142.606,3.318z", repeat:-1,  duration: 1.8,yoyo: true, ease: Power1.easeInOut});
     var anim_morph_forme_bleu = gsap.to(MaskInnerBlue, {morphSVG:"M121.003,30.299C28.239,54.985,0.512,166.645,0.625,224.004c0.251,129.669,203.369,198.558,265.892,6.596c13.189-40.496-17.627-108.339-30.492-135.923C216.597,53.03,193.538,11,121.003,30.299z", repeat:-1,  duration: 3,yoyo: true, ease: Power1.easeInOut});
 }

 function hoverOff(elt){
   TweenMax.killTweensOf(togItemsArray);
   var anim_morph_agence = gsap.to(GlobalMask, {morphSVG:"M142.606,3.318C47.06,24.734,61.966,67.626,48.136,74.51C-11.836,104.36,1.156,178.394,1.248,225.004c0.251,129.669,203.369,198.559,265.893,6.597c13.19-40.497,14.949-82.417,2.084-110c-12.083-25.901,20.415-78.317-11.089-82.282C238.985,36.909,216.078-13.149,142.606,3.318z", repeat:0, yoyo:false, duration: 1, ease: Power2.easeOut});
   var anim_morph_forme_bleu = gsap.to(MaskInnerBlue, {morphSVG:"M134.489,81.483C41.725,106.169,0.512,166.645,0.625,224.004c0.251,129.669,203.369,198.558,265.892,6.596c13.189-40.496,14.949-82.416,2.084-110C249.173,78.953,207.024,62.185,134.489,81.483z", repeat:0,  duration: 1.8,yoyo: false, ease: Power2.easeOut});
 }


togTeamMember.mouseenter(function(e){
      hoverOn(this);
});

togTeamMember.mouseleave(function(e){
      hoverOff(this);
 });




  /*************/
      /* VRAI CODE-  */
/*************/

// Forme en haut à gauche de toute les formes 
var DrawTopLeft=  gsap.to("path.drawTopLeft", {morphSVG:"M0.889,0.444c0,0,1012-1,1251.811,0c-125.811,201-611.811,184-786.918,233.265C295.973,281.483,163.519,580.593,0.889,607.18C-1.111,525.444,0.889,0.444,0.889,0.444z", repeat:-1,  duration: 2.6 ,yoyo: true, ease: Power2.easeInOut});  

// Home Forme
var RondAgence1 =  gsap.to("path.path_rond_agence_1", {morphSVG:"M69.408,126.333c59.092-2.313,77.019-96.566,47.405-109.442C81.556,1.562,28.72,8.738,11.233,22.899C-13.698,43.09,17.472,128.367,69.408,126.333z", repeat:-1,  duration: 1.8,yoyo: true, ease: Power2.easeInOut});
var Path_last_article_bottom = gsap.to("path.path_last_article_bottom", {morphSVG:"M1575.809,117.456c-40.48-7.3-79.453,7.655-103.592,32.526c-38.59,39.76-68.994,47.943-105.244,7.015c-36.252-40.929-63.225-23.831-53.867,7.156c9.354,30.989-35.92,52.232-80.357,17.151c-44.438-35.082-90.887-31.908-159.881,46.442c-68.994,78.349-136.327,63.698-190.119,2.891c-53.792-60.81-108.392-94.502-154-22c-45.605,72.502-130.652,63.546-104.926,2.738c25.726-60.808-37.027-107.268-80.294-38.274c-43.268,68.994-96.351,23.719-86.996,1.5c9.356-22.22-26.898-43.599-68.997-1.5c-42.098,42.098-50.208,48.891-107.515-4.992c-27.332-25.699-100.939-23.008-136.973-29.506c-65.58-11.83-83.534-58.703-132.061-104.372L0,23.889v481.856h1944.686V23.969C1944.686,23.969,1784.083,146.636,1575.809,117.456 M559.953,238.07c-4.979-8.752,6.539-18.613,14.393-19.675c12.461-1.684,21.979,7.802,9.261,22.108C575.032,250.152,564.021,245.218,559.953,238.07 M571.313,335.828c-13.967-17.111-0.564-49.537,19.55-55.172c12.588-3.525,31.816,14.383,32.011,35.454C623.15,345.329,585.769,353.527,571.313,335.828 M657.062,291.811c-4.328,4.17-14.055,7.08-14.331-1.714c-0.209-6.716,5.322-10.286,9.414-9.039c7.863,2.394,6.711,9.94,2.785,13.724", repeat:-1,  duration: 3.5,yoyo: true, ease: Power2.easeInOut});

var RondContact2 =  gsap.to("path.rond_contact_home", {morphSVG:"M67.625,190.371C196.703,184.116,208.721,86.69,137.477,9.438C84.678-47.814-60.332,196.571,67.625,190.371z", repeat:-1,  duration: 1.8,yoyo: true, ease: Power2.easeInOut});

var FooterTop =  gsap.to("path.footer_top", {morphSVG:"M1920,74.033h-0.333H0V13.637C90.5,59.533,347.509,12.7,815,12.7c468,0,625,60.409,1105,7.833", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});

var HeaderTopPage =  gsap.to("path.path_top_headerPage", {morphSVG:"M1574.356,140.648C1216.283,9.904,1078,91.191,658,129.191c-307.348,27.808-522-19.218-658-72v162.755h1920v-90.755C1784,161.191,1711.037,190.555,1574.356,140.648z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});

var HeaderTopPage2Bleu =  gsap.to("path.path_top_headerPage2", {morphSVG:"M874.641,52.506C406.123-6.854,66,23.755,0,24.059v106.755h1920V59.143C1621.062,74.729,1404.5,119.638,874.641,52.506z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});
// attention, top page services mais aussi top other post dans single post

var HeaderTopArchiveActus =  gsap.to("path.path_archive_actus", {morphSVG:"M1560.916,222.838c-103.495,6-193.732-60.867-338.982-74.996c-145.252-14.128-289.85,27.341-429.112,21.003c-139.262-6.337-139.36-55.501-400.729-31.393C159.986,137.253,83.899,245.478,0,245.782v28.724h1920V69.846C1914.151,89.782,1795.208,209.255,1560.916,222.838z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});


var HeaderTopRea =  gsap.to("path.path_top_realisation", {morphSVG:"M0,89.433v72.666h1920v-53.167c0,0-199.081-56.997-713.903-56.997S0,89.433,0,89.433z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});


/* FORME VAGUE SINGLE REA */
var TopVague =  gsap.to("path.path_top_vaguerea", {morphSVG:"M557.128,60.445c536.973-43.514,1201.44,0,1362.872,20.983V0H0v119.235C34.129,108.342,79.846,99.122,557.128,60.445z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});
var BottomVague =  gsap.to("path.path_bottom_vaguerea", {morphSVG:"M1548.009,217.313c-250.93,36.614-210.668,30.431-356.41,22.919c-145.743-7.51-231.075-37.498-370.481-37.498c-139.406,0-266.986-7.5-408.633-34.241C174.407,123.547,144.651,148.816,0,172.735v155.07h1920v-66.574C1806.568,219.233,1771.803,184.657,1548.009,217.313z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});
/* FIN FORME VAGUE */


/* FORME VAGUE CHIFFE CLES REA */
var TopChiffreCles =  gsap.to("path.path_top_chiffrescles", {morphSVG:"M599,117c635.625,25.836,1020-78,1321-12V0H0v154.274C247,47,245.101,102.615,599,117z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});
var BottomChiffreCles =  gsap.to("path.path_bottom_chiffrescles", {morphSVG:"M1218,85.712c-476.798,29.146-694-152-1218-10v33h1920v-65C1538,11.712,1511.903,67.746,1218,85.712z", repeat:-1, delay:2,  duration: 4,yoyo: true, ease: Power2.easeInOut});

/* FORME LEST ARCHIVE PROJET */
var LeftArchiveProjet =  gsap.to("path.path_left_archive_projet", {morphSVG:"M65.094,705.415c-1.581-46.381,81.261-185.303,83.564-238.488c5.535-127.81-102.513-55.787-118.062-200.99C18.499,152.952,100.447-1.409,0,0.014V1130.98c29.947-8.217,77.438-15.118,74.432-110.581c-2.82-89.562,34.77-87.516,32.661-164.992C104.986,777.93,66.676,751.795,65.094,705.415z", repeat:-1,  duration: 4,yoyo: true, ease: Power2.easeInOut});




/* Forme PAGES GLOABALES */
var Main_txt_bleuc =  gsap.to("path.main_txt_bleuc", {morphSVG:"M40.806,102.577c39.07-1.815,77.117-83.203,19.334-96.618C35.192,0.167,10.091,6.317,4.142,23.858C-3.777,47.216,6.467,104.173,40.806,102.577z", repeat:-1,  duration: 1.8,yoyo: true, ease: Power2.easeInOut});

var Main_txt_orange =  gsap.to("path.main_txt_orange", {morphSVG:"M164.42,116.205C120.375-64.996-23.392-3.057,5.3,112.95C27.253,180.868,183.966,196.617,164.42,116.205z", repeat:-1,  duration: 2,yoyo: true, ease: Power1.easeInOut});

var Main_txt_bleuf =  gsap.to("path.main_txt_bleuf", {morphSVG:"M106.52,187.531c102.017,4.84,107.214-112.662,30.358-169.912C36.318-57.288-72.348,179.046,106.52,187.531z", repeat:-1,  duration: 3,yoyo: true, ease: Power1.easeInOut});

var Top_customers =  gsap.to("path.top_customers", {morphSVG:"M0,45.593c0,0,392.575,56.997,960.404,38.301C1523.311,65.359,1920,68.671,1920,68.671V0H0", repeat:-1,  duration: 4,yoyo: true, ease: Power1.easeInOut});

var Top_part_studio =  gsap.to("path.top_part_studio", {morphSVG:"M0.063,56.351c0,0,435.115,45.993,949.937,45.993c509.745,0,961.33-39.285,970-37.189V0H0L0.063,56.351z", repeat:-1,  duration: 4,yoyo: true, ease: Power1.easeInOut});

var Menu_forme_bleuf =  gsap.to("path.menu_forme_bleuf", {morphSVG:"M555.909,213.598c-146.375,161.76-352.411-27.626-483.853,153.475h704v-258C671.057,124.073,655.04,104.048,555.909,213.598z", repeat:-1,  duration: 3.8,yoyo: true, ease: Power1.easeInOut});





  /* *****************  */
    /* SMOOTH SCROLL :  INTRO AUTRE PAGE  */
  /* *****************  */

      var menuItems = $('.ToBottom-btn-page, .NavSItem');
      var offsetTop;
       menuItems.click(function(e){

      var href = $(this).attr("href"),
          offsetTop = href === "#" ? 0 : $(href).offset().top - 80 - 0;
    
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 600);
       
        e.preventDefault();
    });


var $collection = $('.SectionInView');
$collection.each(function () {
   new Waypoint.Inview({
      element: this,
      enter: function(direction) {
        $(this.element).addClass('to_anim');
        // console.log(this.element.id + ' enter');
      },
      entered: function(direction) {
        // console.log(this.element.id + ' entered');
      },
      exit: function(direction) {
         
      },
      exited: function(direction) {
        $(this.element).removeClass('to_anim');
        // console.log(this.element.id + ' exited');
      }
   });
});





 $(window).scroll(function () {
      action_on_scroll();
  });


  function action_on_scroll(){
    l_window = parseInt($(window).width());

       if ($(window).scrollTop() > top_sticky){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
      }else{
          header.removeClass("Masthead--sticky");
          $("body").removeClass('header--sticky');
      }
  }









    /*************/
      /* LOADER PAGE !  */
    /*************/

  jQuery(window).load(function() {
    loader_finish();
  }) ;
   //
 function loader_finish(){
    //console.log('fini');
   // window.setTimeout(attente_loader_finish,0);
    anim_loader_to_insivisble();
  }

  function attente_loader_finish(){
     //$('#loader_page').addClass('to_load');
    // window.setTimeout(anim_loader_to_insivisble,0);
       //loader.addClass("to_transition");
  }
  function anim_loader_to_insivisble(){

    $('body').addClass('load_page');

     window.setTimeout(fin_loader,1000);
  }

  function fin_loader(){
    $('body').removeClass('load_page');
  }

    /*************/
      /* FIN LOADER !  */
    /*************/


   /* *****************  */
    /* CLICK MENU BTN
  /* *****************  */

  // prendre exemple ici : https://www.agencefantastic.com/work

   $( window ).resize(function() {
      // init_size_svg_transition();
  });

 var pos_x = parseInt($(window).width() - 228);
 var forme_dessus_btn = document.getElementById("circle_top_button");
forme_dessus_btn.setAttribute("cx", 272);
forme_dessus_btn.setAttribute("cy", 38);

var ContainerMenuClipped = document.getElementById("ContainerClipped");
attrCircle = document.getElementById("attrCircle");
attrCircle.setAttribute("cx", pos_x);
attrCircle.setAttribute("cy", 38);

if(l_window > 1023){
  forme_dessus_btn.setAttribute("cx", 272);
  forme_dessus_btn.setAttribute("cy", 38);
  attrCircle.setAttribute("cx", pos_x);
  attrCircle.setAttribute("cy", 38);
}else{
   pos_x = parseInt($(window).width() - 44);
  forme_dessus_btn.setAttribute("cx", 256);
  forme_dessus_btn.setAttribute("cy", 30);
  attrCircle.setAttribute("cx", pos_x);
  attrCircle.setAttribute("cy", 30);
}

var scaleX_to_efficience  = parseInt(l_window / 40  * 2 + 12); // 40 = rayon
var scaleY_to_efficience  = parseInt(h_window / 40  * 2 + 12); 
var scale_to_efficience = scaleY_to_efficience;
if(scaleX_to_efficience > scaleY_to_efficience) scale_to_efficience = scaleX_to_efficience;


//gsap.defaults({ smoothOrigin: false }); Pas besoin de ca normalement
function redrawClipPath() {
  ContainerMenuClipped.style.clipPath = "none";
  var width_elt = ContainerMenuClipped.offsetWidth;
  ContainerMenuClipped.style.clipPath = "url(#clipPathGenerateId)";
}

function menu_z_index_behind(){
  $('body').removeClass('z-index-before');
}
function menu_z_index_before(){
  $('body').addClass('z-index-before');
}


   $("#menu-toggle").click(function(e){

      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu z-index-before');
        gsap.to(attrCircle, 0.35, {delay:0.100,scale:scale_to_efficience, transformOrigin: "center center",svgOrigin: "0 0", ease: Power4.easeIn,onUpdate: redrawClipPath, onComplete: menu_z_index_before});
        gsap.to("circle.mask_forme_dessus", 0.4, {scale:2, transformOrigin: "center center",svgOrigin: "0 0", ease: Back.easeOut});
        gsap.to("#forme_x5F_initial", {duration: 1, delay:0.200, morphSVG:"#forme_x5F_final",ease: Power3.easeOut});
        }else{
         $('body').removeClass('open_menu');
         gsap.to(attrCircle, 0.5, {scale:1, transformOrigin: "center center",svgOrigin: "0 0", ease: Power4.easeOut,onUpdate: redrawClipPath, onComplete: menu_z_index_behind});
         gsap.to("circle.mask_forme_dessus", 0.4, {delay:0.400,scale:1, transformOrigin: "center center",svgOrigin: "0 0", ease: Back.easeOut});
         gsap.to("#forme_x5F_initial", {duration: 0.4, delay:0, morphSVG:"#forme_x5F_initial",ease: Power3.easeOut});
        }
   });



  // $("#primary-menu a,a.js-add-loader").click(function(evt){

  //       load_anim();

  //       var link = $(this).attr("href");
  //       setTimeout(function() {
  //           window.location.href = link;
  //       }, 1350);

  //       evt.preventDefault();
  //   });

  // function load_anim(){
  //     $( "body" ).addClass('to_transition');
  // }
  // function to_reset_anim(){
  //   $('body').removeClass('remove_coeur to_transition to_transition_load');
  // }




  // FORM CONTACT LABEL ///

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


   // test scroll depth //
  var maxScrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var percentagesArr = [25,50,75,100];
  const showed = {};
  let timeout;
  let previousPercentage;
  window.addEventListener("scroll", function (event) {
      var scrollVal = this.scrollY;
      var scrollPercentage = Math.round(scrollVal / maxScrollHeight * 100);
      let currentPercentage = 0;
      let i = 0;
      while(percentagesArr[i] <= scrollPercentage) {
        currentPercentage = percentagesArr[i++];
      }
      if (previousPercentage !== currentPercentage) {
          clearTimeout(timeout);
          timeout = currentPercentage !== 0 && !showed[currentPercentage] ? setTimeout(() => {
                console.log(currentPercentage);
                window._paq = window._paq || [];_paq.push(['trackEvent', 'Scroll_depth', currentPercentage+'% '+document.title]);
                showed[currentPercentage] = true;
              }, 2000)
            : null;
          previousPercentage = currentPercentage;
      }
  });

  window.addEventListener("resize", () => {
    maxScrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  });


 });